import { Language } from '../../constants/language';
import { Product, ProductType } from '../../models/product/product';
import { Book } from '../../models/product/book';
import {PaginatedResult, PAGINATION, PaginationUtil} from "../../utils/pagination-util";
import { DISCERNMENT_OF_SPIRITS_BOOK_AR, DISCERNMENT_OF_SPIRITS_BOOK_EN, ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_AR, ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_EN, FACE_TO_FACE_BOOK_AR, FACE_TO_FACE_BOOK_EN, LETTERS_OF_FIRE_BOOK_AR, LETTERS_OF_FIRE_BOOK_EN, POSSESSING_THE_GATES_OF_ENEMY_BOOK_AR, POSSESSING_THE_GATES_OF_ENEMY_BOOK_EN, THE_JOURNEY_BOOK_AR, THE_JOURNEY_BOOK_EN } from './books/book-mock-data';




export const PRODUCTS_MOCK_DATA_EN: Book[] = [
  DISCERNMENT_OF_SPIRITS_BOOK_EN,  
  POSSESSING_THE_GATES_OF_ENEMY_BOOK_EN,
  ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_EN,
  LETTERS_OF_FIRE_BOOK_EN,
  THE_JOURNEY_BOOK_EN,
  FACE_TO_FACE_BOOK_EN

];

export const PRODUCTS_MOCK_DATA_AR: Book[] = [
  DISCERNMENT_OF_SPIRITS_BOOK_AR,
  POSSESSING_THE_GATES_OF_ENEMY_BOOK_AR,
  ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_AR,
  LETTERS_OF_FIRE_BOOK_AR,
  THE_JOURNEY_BOOK_AR,
  FACE_TO_FACE_BOOK_AR
];

export const getProductsLocalized = (
    language: Language = Language.AR,
    productType: ProductType = ProductType.ALL,
    fetchAll: boolean = false,
    page: number =  PAGINATION.DEFAULT_PAGE,
    limit: number = PAGINATION.DEFAULT_PAGE_SIZE): PaginatedResult<Product> => {

    const products = language === Language.AR ? PRODUCTS_MOCK_DATA_AR : PRODUCTS_MOCK_DATA_EN;
    const actualLimit = fetchAll ? -1 : limit;
    const filteredProducts =  productType === ProductType.ALL ?
                                                          products :
                                                          products.filter(product => product.type === productType);
    return PaginationUtil.paginate<Product>(filteredProducts, page, actualLimit);
};